// The "Copy Embed Code" snippet, and the message the embedded form sends to
// the page around it (OL-224).
//
// The form posts its height whenever it changes; the snippet's script sets the
// iframe to that height, so nothing is cut off and the confirmation leaves no
// empty space behind it. An embed copied before OL-224 has no script and keeps
// its fixed height.

export const EMBED_MESSAGE_TYPE = 'oak-legal:form-height';

/** The message an embedded form posts. `scroll` asks the page to bring it into view. */
export const embedHeightMessage = (height, { scroll = false } = {}) => ({
  type: EMBED_MESSAGE_TYPE,
  height: Math.ceil(height),
  scroll,
});

const escapeAttribute = (value) => String(value)
  .replace(/&/g, '&amp;')
  .replace(/"/g, '&quot;')
  .replace(/</g, '&lt;');

/**
 * The iframe plus a short script that resizes it. The script only listens to
 * its own iframe, from the app's own origin.
 */
export const buildEmbedCode = ({ src, title, origin, frameId }) => {
  const iframe = `<iframe id="${frameId}" src="${escapeAttribute(src)}" title="${escapeAttribute(title || 'Intake Form')}" width="100%" height="549" style="width:100%;border:0;" frameborder="0" referrerpolicy="strict-origin-when-cross-origin"></iframe>`;

  const script = '<script>(function(){'
    + `var f=document.getElementById(${JSON.stringify(frameId)});if(!f)return;`
    + 'window.addEventListener("message",function(e){var d=e.data;'
    + `if(e.origin!==${JSON.stringify(origin)}||e.source!==f.contentWindow||!d||d.type!==${JSON.stringify(EMBED_MESSAGE_TYPE)})return;`
    + 'f.style.height=Math.ceil(d.height)+"px";'
    + 'if(d.scroll){var r=f.getBoundingClientRect();if(r.top<0||r.top>window.innerHeight)f.scrollIntoView({behavior:"smooth",block:"start"});}'
    + '});})();</script>';

  return `${iframe}\n${script}`;
};
